import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Speedo = forwardRef<SVGSVGElement, Partial<IconProps>>(function Speedo({
  styles,
  ...props
}, ref) {
  return <Icon title="Speedo" description="A dial measurement icon" ref={ref} {...stylex.props(styles)} viewBox="0 0 36 36" {...props}>
        <path {...stylex.props(iconsStyles.lightElement)} d="M29.3 27c1 0 2-.6 2.5-1.5A15 15 0 0 0 18 4.5a15 15 0 0 0-13.8 21c.5 1 1.5 1.5 2.5 1.5h22.6Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M22 13.9c.1-1.2-1.3-1.6-1.9-.5L16.6 21a4.6 4.6 0 0 0 .2 8.8c2.4.6 4.9-.9 5.5-3.3.5-1.6 0-3.1-1-4.3.4-3 .6-6 .8-8.4Z" />
      </Icon>;
});